import { j as s } from "./jsx-runtime-C5mzlN2N.js";
const m = (t) => ({
  getRoutes: () => Object.entries(t.fileImports).map(
    ([e, n]) => ({
      path: e,
      lazy: async () => {
        const { MdxPage: o } = await import("./MdxPage-DVI4iYgW.js"), { default: a, ...r } = await n();
        return {
          element: /* @__PURE__ */ s.jsx(
            o,
            {
              mdxComponent: a,
              ...r,
              defaultOptions: t.defaultOptions
            }
          )
        };
      }
    })
  )
});
export {
  m as markdownPlugin
};
//# sourceMappingURL=zudoku.plugin-markdown.js.map
